/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 03.09.2014
 *   Time: 16:55
 */

import { LiveEnvironment } from "./LiveEnvironment";

export class PrivateTestEnvironment extends LiveEnvironment {
    public static PRIVATE_TEST_ENVIRONMENT_ID: string = "PrivateTestEnvironment";

    constructor() {
        super(PrivateTestEnvironment.PRIVATE_TEST_ENVIRONMENT_ID);
    }

    public isSupported(): boolean {
        return this._data.globals.isPrivateTestServer;
    }
}
